function NotFound()
    {
        return (
            <main>
                <p>Not Found</p>
            </main>
        )
    }

export default NotFound;